import React from 'react';
import { AppShell } from './AppShell';

export const AdminLayout: React.FC = () => <AppShell variant="admin" />;
